// extracted by mini-css-extract-plugin
module.exports = {"sitewideBanner":"SitewideBanner_sitewideBanner__ybELz"};